import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledBasePagination = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-13psekq-0"
})(["display:flex;width:fit-content;flex-wrap:wrap;&& > *{margin-inline-end:", ";}&& > *:last-child{margin-inline-end:0;}", ""], ({
  theme
}) => theme.pagination.paginationItemMargin, isMobile(css(["flex-direction:column;width:auto;align-items:center;&& > *{margin-inline-start:0;margin-inline-end:0;margin-bottom:", ";}&& > *:last-child{margin-inline-start:0;margin-inline-end:0;margin-bottom:0;}"], ({
  theme
}) => theme.pagination.mobile.paginationItemMargin)));
const PaginationNavGroup = /*#__PURE__*/styled('nav').withConfig({
  componentId: "sc-storm-ui-30060407__sc-13psekq-1"
})(["display:flex;flex-direction:row;flex-wrap:nowrap;&& > *{margin-inline-end:", ";}&& > *:last-child{margin-inline-end:0;}"], ({
  theme
}) => theme.pagination.paginationNavGroupMargin);

export { PaginationNavGroup as P, StyledBasePagination as S };
//# sourceMappingURL=Pagination.styles-Z9Y5g2XX.js.map
